import { Grid } from "@mui/material";
import { useInstance } from "../../../../node_modules/easy-redux-http-call/dist/index";
import { AI_getAnnouncementList } from "APIs/announcement";
import { useEffect, useMemo } from "react";
import { makeStyles } from "@mui/styles";

const useStyle = makeStyles(() => ({
  AnnouncementContainer : {
    display : "flex",
    overflow: "hidden",
    height: "2rem",
    margin : "auto 1rem",
    flex: "1 1 auto",
    boxSizing: "content-box",
    "& > div" : {
      display: "inline-block",
      height: "2rem",
      lineHeight: "2rem",
      whiteSpace: "nowrap",
      boxSizing: "content-box",
      "-webkit-animation-iteration-count": "infinite",
      "animation-iteration-count": "infinite",
      "-webkit-animation-timing-function": "linear",
      "animation-timing-function": "linear",
      "-webkit-animation-name": "$ticker",
      "animation-name": "$ticker",
      "-webkit-animation-duration": "2s",
      "animation-duration": "2s",
      "animation-direction" : "normal",
      pointerEvents :"none",
      userSelect : "none",
      "& > div" : {
        display: "inline-block",
        padding: "0 2rem",
      }
    }
  },
  "@keyframes ticker": {
      "0%" : {
        "-webkit-transform": "translate3d(0, 0, 0)",
        transform: "translate3d(0, 0, 0)",
      },
      "100%" : {
        "-webkit-transform": "translate3d(min(calc(-100vw + 400px) , -200%), 0, 0)",
        transform: "translate3d(min(calc(-100vw + 400px) , -200%), 0, 0)",
      },
  },
}))

const AnnouncementStrip = ({ }) => {
  const classes = useStyle();
  const announcementReduxState = useInstance(AI_getAnnouncementList);

  const [annoucements , duration] = useMemo(() => {
    let rows = announcementReduxState?.data?.rows?.filter(ann => ann.active) ?? []
    let totalCharacters = rows?.map(a => a?.description)?.join("").length
    return [rows , totalCharacters * 0.2]
  },[announcementReduxState])

  useEffect(() => {
    AI_getAnnouncementList.call({
      params: {
        q: "",
        order_by: "createdAt",
        sort_by: "desc",
        page: 0,
        limit: 1000,
        active:"true"
      },
    });
  },[])

  if(annoucements?.length == 0){
    return null
  } else return (
    
      <Grid className={classes.AnnouncementContainer}>
        <span
        style={{
          minWidth : "100%",
          minHeight : "100%",
          display : "flex",
        }}
        ></span>
        <div 
        style={{
              "-webkit-animation-duration": `max(${duration}s , 20s)`,
              "animation-duration": `max(${duration}s , 20s)`,
        }}
        >
        {annoucements?.map(ann => {
          return <div key={ann.title}><b>{ann.title}: {" "}</b> {ann.description} </div>
          })}
        </div>
      </Grid>
    
  );
};


export default AnnouncementStrip;
